export default __webpack_public_path__ + "static/media/[BTCLOD.COM] Black Sherif - Second Sermon (Official Video)-320k.ae008c5d.mp3";